import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="yu-baby-message-callback"
export default class extends Controller {
  static outlets = ['yu-baby']

  connect() {
    this.yuBabyOutlet.createMessage()
    this.element.remove()
  }
}
